<script lang="ts">
    import Pixelboard from "./components/Pixelboard.svelte";
    import ColorPicker from "./components/ColorPicker.svelte";
</script>

<div class="app-container">
    <div class="center">
        <Pixelboard />
        <ColorPicker />
    </div>
</div>

<style>
    .app-container {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
    }

    .center {
        grid-column: 2;
    }
</style>
